module.exports = __webpack_public_path__ + "img/frame15_stamp.d114e3b6.png";